<template>
  <div class="storePicking">
    <div class="title">仓库拣货信息</div>
    <div class="content">
      <Product
        class="product"
        v-for="(item, index) in expectProductCategories"
        :key="index"
        :productInfo="item"
      ></Product>
      <div class="line"></div>
      <Statistics v-bind="$attrs"></Statistics>
    </div>
  </div>
</template>

<script>
import Product from "./product";
import Statistics from "./statistics";
export default {
  inheritAttrs: true,
  props: ["expectProductCategories"],
  components: { Product, Statistics },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.storePicking {
  width: 100%;
  min-height: 300px;
  margin-top: 40px;
  .title {
    width: 250px;
    height: 45px;
    line-height: 45px;
    color: rgba(0, 0, 0, 0.9);
    font-size: 32px;
    font-weight: bold;
    margin-left: 32px;
  }
  .content {
    background: rgba(255, 255, 255, 1);
    border-radius: 16px;
    padding: 32px;
    margin-top: 32px;
    .product {
      margin-bottom: 32px;
    }
    .line {
      width: 100%;
      height: 0;
      border-top: 1px dashed rgba(226, 228, 234, 1);
      margin-bottom: 24px;
    }
  }
}
</style>
